<div [ngClass]="{'open': open()}" class="sidebar is-flex is-flex-direction-column">
  <div class="wrapper-close-x">
    <div (click)="closeSidebar()" class="toggle-icon">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
  <div class="wrapper-sidbar-fixed">
    <div class="brand">
      <a class="navbar-brand navbar-brand-d logo" routerLink="/home" (click)="onNavigationClick()">
        <span>Bueno</span>
      </a>
      @if (userName() != '') {
      <div class="text_lg has-text-weight-bold greetings">{{ greeting|translate }}, {{ userName() }}</div>
      }
    </div>
  </div>
  <app-route-search (routeSelected)="onNavigationClick()"></app-route-search>
  <div class="sidebar-container">
    <div class="inner-sidebar-container">
      <aside class="menu is-flex is-flex-direction-column is-justify-content-space-between">
        <ul class="menu-list">
          @for (item of sidebarNavigationList; track item) { @if(!((item.hideIfOnlyProperties && onlyProperties()))) {
          <li>
            <div
              class="menu-item-row"
              [routerLinkActive]="'is-active-row'"
              (mouseenter)="showInfoBubble(item.infoBubbleKey)"
              (mouseleave)="hideInfoBubble(item.infoBubbleKey)"
              (focusin)="showInfoBubble(item.infoBubbleKey)"
              (focusout)="hideInfoBubble(item.infoBubbleKey)">
              <a
                routerLink="{{ item.url }}"
                class="has-text-decoration-none is-flex is-align-items-center gap-3"
                [routerLinkActive]="'is-active'"
                (click)="onNavigationClick()">
                <mat-icon class="icon-sidebar" svgIcon="{{item.icon}}"></mat-icon>
                <span class="name-page">{{ item.name |translate }}</span>
              </a>
              @if (item.infoBubbleKey === 'directDebit' && isInfoBubbleAvailable('directDebit')) {
              <button
                #directDebitInfoButton
                type="button"
                class="info-bubble-button"
                [class.is-open]="isInfoBubbleOpen('directDebit')"
                [attr.aria-expanded]="isInfoBubbleOpen('directDebit')"
                (click)="toggleInfoBubble('directDebit', $event)">
                <span class="info-bubble-icon" aria-hidden="true">i</span>
              </button>
              } @if (item.infoBubbleKey === 'directDebit' && isInfoBubbleVisible('directDebit')) {
              <div
                #infoBubble
                class="info-bubble"
                role="dialog"
                aria-modal="false"
                aria-labelledby="direct-debit-info-title"
                (mouseenter)="showInfoBubble('directDebit')"
                (mouseleave)="hideInfoBubble('directDebit')">
                <button
                  type="button"
                  class="info-bubble-close"
                  [attr.aria-label]="'CLOSE' | translate"
                  (click)="dismissInfoBubble('directDebit', $event)">
                  <span aria-hidden="true">&times;</span>
                </button>
                <span id="direct-debit-info-title" class="info-bubble-eyebrow">
                  {{ 'DIRECT_DEBITS.FORM.TITLE' | translate }}
                </span>
                <p class="info-bubble-text">{{ 'DIRECT_DEBITS.FORM.DASHBOARD.BANNER' | translate }}</p>
                <a class="info-bubble-cta" [routerLink]="item.url" (click)="onNavigationClick()">
                  {{ 'DIRECT_DEBITS.FORM.NEW' | translate }}
                </a>
              </div>
              }
            </div>
          </li>
          } }
        </ul>
        <div class="bottom_menu">
          <ul class="menu-list referral">
            <li>
              @if (showCopyConfirmation) {
              <div class="copy-confirmation">
                <mat-icon>check_circle</mat-icon>
                <span>{{ 'REFERRAL_LINK_COPIED' | translate }}</span>
              </div>
              }
              <div
                class="referral-link-wrapper"
                (mouseenter)="showInfoBubble('referral')"
                (mouseleave)="hideInfoBubble('referral')"
                (focusin)="showInfoBubble('referral')"
                (focusout)="hideInfoBubble('referral')">
                <a
                  class="has-text-decoration-none is-flex is-align-items-center gap-3 referral-link"
                  [routerLink]="'/account/refer-a-friend'"
                  (click)="onNavigationClick()">
                  <mat-icon class="icon-sidebar" svgIcon="bueno-referral"></mat-icon>
                  <span class="name-page">{{'SHARE_BUENO' |translate }}</span>
                </a>
                @if (isInfoBubbleAvailable('referral')) {
                <button
                  #referralInfoButton
                  type="button"
                  class="info-bubble-button"
                  [class.is-open]="isInfoBubbleOpen('referral')"
                  [attr.aria-expanded]="isInfoBubbleOpen('referral')"
                  (click)="toggleInfoBubble('referral', $event)">
                  <span class="info-bubble-icon" aria-hidden="true">i</span>
                </button>
                } @if (isInfoBubbleVisible('referral')) {
                <div
                  #infoBubble
                  class="info-bubble"
                  role="dialog"
                  aria-modal="false"
                  aria-labelledby="referral-info-title"
                  (mouseenter)="showInfoBubble('referral')"
                  (mouseleave)="hideInfoBubble('referral')">
                  <button
                    type="button"
                    class="info-bubble-close"
                    [attr.aria-label]="'CLOSE' | translate"
                    (click)="dismissInfoBubble('referral', $event)">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <span class="info-bubble-eyebrow">{{ 'REFER_A_FRIEND.SUMMER_OFFER' | translate }}</span>
                  <strong id="referral-info-title" class="info-bubble-title">
                    {{ 'REFER_A_FRIEND.HERO_TEXT' | translate }}
                  </strong>
                  <div class="referral-info-reward" aria-hidden="true">
                    <span class="referral-info-reward__item">
                      <b>&euro;30</b>
                      <small>{{ 'REFER_A_FRIEND.FOR_YOU' | translate }}</small>
                    </span>
                    <span class="referral-info-reward__plus">+</span>
                    <span class="referral-info-reward__item">
                      <b> &euro;30<sup class="referral-info-reward__footnote-marker">*</sup> </b>
                      <small>{{ 'REFER_A_FRIEND.FOR_FRIEND' | translate }}</small>
                    </span>
                  </div>
                </div>
                }
              </div>
            </li>
          </ul>
          <div class="row"></div>
          <ul class="menu-list">
            @for (item of bottomNavigationList; track item) {
            <li>
              @if (!item.remoteLink) {
              <a
                routerLink="{{ item.url }}"
                class="has-text-decoration-none is-flex is-align-items-center gap-3"
                [routerLinkActive]="'is-active'"
                (click)="onNavigationClick()">
                <mat-icon class="icon-sidebar" svgIcon="{{item.icon}}"></mat-icon>
                <span class="name-page">{{ item.name |translate }}</span>
              </a>
              } @else {
              <a
                href="{{ item.url }}"
                target="_blank"
                class="has-text-decoration-none is-flex is-align-items-center gap-3"
                [routerLinkActive]="'is-active'"
                (click)="onNavigationClick()">
                <mat-icon class="icon-sidebar" svgIcon="{{item.icon}}"></mat-icon>

                <span class="name-page">{{ item.name |translate }}</span>
              </a>
              }
            </li>
            }
          </ul>
        </div>
      </aside>
    </div>
  </div>
</div>
